import React, { ComponentPropsWithoutRef } from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { CloseIcon } from '@biome-design-system/icons/CloseIcon';

import type { SearchModification, SearchSummary } from 'Src/types';

import { DISTANCE_ANY } from '../../../facet-panel/facet-list/location-facet';
import { FilterChip } from '../../styles';
import { CHIP_ROLE } from '../../constants';
import messages from '../messages';
import type { BaseChipProps } from '.';
import { UnappliedChip } from './UnappliedChip';

interface BaseLocationChipProps
  extends BaseChipProps,
    ComponentPropsWithoutRef<'div'> {
  updateSearch: (modifications: SearchModification[]) => void;
  searchSummary: SearchSummary;
  onClick: () => void;
}

type LocationChipProps = WrappedComponentProps & BaseLocationChipProps;

export const LocationChip = injectIntl(
  ({
    intl,
    searchSummary,
    onClick,
    updateSearch,
    log,
    ...props
  }: LocationChipProps) => {
    const handleDelete = () => {
      updateSearch([
        { action: 'delete_key', key: 'display_location' },
        { action: 'delete_key', key: 'location' },
        { action: 'delete_key', key: 'distance' },
        { action: 'delete_key', key: 'search_coordinates' }
      ]);
    };

    const chipLabel = intl.formatMessage(
      messages.appliedLocationFilterChipLabel,
      {
        location: searchSummary.display_location ?? searchSummary.location,
        distance: searchSummary.distance || DISTANCE_ANY
      }
    );

    if (searchSummary.location) {
      return (
        <FilterChip
          {...props}
          aria-label={intl.formatMessage(messages.filterChipAriaLabel, {
            chipLabel
          })}
          color="primary"
          role={CHIP_ROLE}
          data-testid="filter-chip-location"
          label={chipLabel}
          onClick={onClick}
          onDelete={handleDelete}
          deleteIcon={
            <CloseIcon
              aria-hidden="true"
              color="inherit"
              titleAccess={intl.formatMessage(messages.removeFilterChipLabel)}
            />
          }
        />
      );
    }
    return (
      <UnappliedChip
        {...props}
        color="primary"
        role={CHIP_ROLE}
        data-testid="filter-chip-location"
        onClick={onClick}
        log={log}
      />
    );
  }
);
